import { object, shape } from 'prop-types';
import React from 'react';
import { ExpandableInput } from '@eika/expandable-input';
import classNames from 'classnames';
import { SkjemaSporsmal } from '../../ahv-schema';
import {
    BM_FATCA_IKKE_TIN,
    BM_FATCA_V2_IKKE_TIN,
    BM_FINANSIELL_INSTUTISJON_IKKE_GIN_ARSAK,
    PM_FATCA_IKKE_TIN,
    PM_FATCA_V2_IKKE_TIN,
} from '../../constants/definisjoner';
import connect from '../helper/connect';
import { isTextEmpty, validerMonster } from '../helper/validation-helper';
import ErrorMessage from '../errormessage';

function isValidTextareaTINSibling(siblingValue, myDefinition) {
    return (
        siblingValue.length === 11 &&
        [PM_FATCA_IKKE_TIN, BM_FATCA_IKKE_TIN, PM_FATCA_V2_IKKE_TIN, BM_FATCA_V2_IKKE_TIN].includes(myDefinition)
    );
}

function isValidTextareaGINSibling(siblingValue, myDefinition) {
    return siblingValue.length === 19 && [BM_FINANSIELL_INSTUTISJON_IKKE_GIN_ARSAK].includes(myDefinition);
}

function TextAreaQuestionType(props) {
    const { question, context, isSubQuestion } = props;
    const { definisjon, instruks, sporsmalstekst, valideringsMonster, validateIfNotSet, reminder = false } = question;

    const hasError = () => {
        if (validateIfNotSet && validateIfNotSet.length > 0) {
            const siblingValue = context.getValue(validateIfNotSet[0].definisjon);
            if (
                isValidTextareaTINSibling(siblingValue, definisjon) ||
                isValidTextareaGINSibling(siblingValue, definisjon)
            ) {
                return false;
            }
        }

        const currentValue = context.getValue(definisjon);
        const touched = context.touched(definisjon);
        const hasSubmitted = context.getHasSubmitted();
        const textEmpty = isTextEmpty(currentValue);
        const gyldigMonster = !validerMonster(currentValue, valideringsMonster);

        return (touched || hasSubmitted) && (textEmpty || gyldigMonster);
    };

    const onChange = (e) => {
        context.onChange(definisjon, { value: e.target.value, error: hasError() });
    };

    const hasInvalidValue = hasError();

    return (
        <div className={classNames({ 'has-error error': hasInvalidValue })}>
            {isSubQuestion && <h2 className="skjema-input-question">{sporsmalstekst}</h2>}
            <ExpandableInput
                name={definisjon}
                onChange={onChange}
                maxRows={4}
                className="form-control"
                value={context.getValue(definisjon)}
                id={definisjon}
                onBlur={() => context.updateValidation(definisjon, true, hasError())}
            />
            {reminder && (
                <div className="skjema-input-reminder">
                    <div className="ikon-utropstegn-36 exclamationmark" />
                    {reminder}
                </div>
            )}
            {hasInvalidValue && <ErrorMessage text={instruks} />}
        </div>
    );
}

TextAreaQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(TextAreaQuestionType));
